export default {
  note: {
    title: 'Uwagi specjalne:',
    description: 'Postaramy się spełnić prośby, ale nie możemy wprowadzać zmian wpływających na cenę.',
    placeholder: 'Dodaj specjalną prośbę',
  },
  buttons: {
    add: '+ Dodaj pozycję',
    update_item: 'Aktualizuj',
    add_to_card: 'Dodaj do koszyka',
  },
  alcohol_warning: 'Ten artykuł jest objęty ograniczeniem wiekowym.',
  caffeine_warning:
    'Zwiększona zawartość kofeiny. Niezalecane dla dzieci ani kobiet w ciąży lub karmiących piersią.{{value}}',
  error_messages: {
    product_unavailable: 'Wyprzedane!',
    item_not_added: 'Nie udało się dodać pozycji. Spróbuj ponownie.',
  },
  success_messages: {
    item_added: 'Pozycja dodana pomyślnie',
  },
};
